import ImageWithFallback from "components/ImageWithFallback"
import React from "react"
import {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import {Card, Image, Button, Icon} from "semantic-ui-react"
import MediaQuery from "react-responsive"
import { Col, Row } from "elemental-react16"
import Responsive           from "react-responsive"
import Slider from "react-slick"; // Import a slider library like react-slick
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import shop from "shop/shop"
import categoryStore     from "stores/categoryStore"

export default class CategoryCard extends Component {

	render() {
		const {category, hasParents, className = "", fakeParent, title = true, overflow, fallback = "//placehold.it/420x240/f5f5f5/&text=X"} = this.props
		//console.log("CategoryCard overflow", category, this.props)
		if ( !hasParents && !fakeParent && category ) {
			return	<Fragment>
				<MediaQuery maxWidth={767}>
				<Card className={`CategoryCard mobileVersion ${className}`} as={Link} to={`/collection/${category.map_id}`} 
							style={{   backgroundSize: "cover", backgroundPosition: "center", minWidth: "450px", minHeight: "250px"}}>
								<Image src={`url("${category.img_src_medium}")`} ></Image>
								<div className={" white db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle"} style={{borderRadius: "15px"}}>{category.desc.short_des}</div>
								</Card>
				</MediaQuery>
				<MediaQuery minWidth={768}>
				<Card className={`CategoryCard  ${className}`} as={Link} to={`/collection/${category.map_id}`} 
							style={{ backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "250px", }}>
								<Image src={`url("${category.img_src_medium}")`} ></Image>
								<div className={" white br4 db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle"} style={{borderRadius: "15px"}}>{category.desc.short_des}</div>
								</Card>
					</MediaQuery>
				</Fragment>
		}

		if ( !hasParents && fakeParent ) {
			return (
				<MediaQuery maxWidth={767}>
					{(matches) =>
						matches ? (
							<Card className={`CategoryCard searchToken ${className}`} as={Link} to={`/collection/${category.parent}/${category.map_id}`}
							style={{backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "250px" }}>
								<Image src={`url("${category.img_src_medium}")`} ></Image>
								<div className={" white db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle "}>{category.desc.short_des}</div>
								</Card>
						) : (
							<Card className={`CategoryCard searchToken ${className}`} as={Link} to={`/collection/${category.parent}/${category.map_id}`} 
							style={{backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "250px" }}>
								<Image src={`url("${category.img_src_medium}")`} ></Image>
								<div className={" white db pa3 mt4 f4 b hover-white underline-hover transition LinkBackgroundStyle "}>{category.desc.short_des}</div>
								</Card>
							
						)
					}
				</MediaQuery>
			);
		}

		if ( category.getParents && overflow ) {
			//console.log("CategoryCard", category)
			let parents = category.getParents()
			const base = `/collection/${parents.map( id => `${id}/` ).join( "" )}${category.title}/`
			return (
				<MediaQuery maxWidth={767}>
					{(matches) =>
						matches ? (
							<Card
							className={`CategoryCard ${className}`}>
								<Image src={`url("${category.img_src}")`} ></Image> {/*backgroundImage: `url("${category.img_src}")` */}
								<div className="white pa2 pa3-ns" style={{ backgroundColor: `white`, backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "240px", maxHeight: "240px" }}>
								<p className="black-30 pt3 f5 b pl4">{category.desc.desc && category.desc.desc.length > 0 ? <p className="black-50 f6 pt2">
									{category.desc.desc.substring(0, 40)}
									{category.desc.desc.length > 1 ? "..." : ""}
              </p> : <p className="black-50 f6 pt2">{category.title}</p>}</p>
								<Link className={"black db pa3 pl4 pt5 mt4 f3 b hover-primary underline-hover transition LinkBackgroundStyle"} to={base}>{category.desc.short_des}</Link>
								<Link className={" $primary db pl4 pr3 pb4 f5 b hover-primary underline-hover transition LinkBackgroundStyle"} style={{color: "#a2cf66"}} to={base}>Produkte ansehen</Link>

							</div>
						</Card>)
						: (
							<Card
							className={`CategoryCard ${className}`}>
								<Image src={`url("${category.img_src}")`} ></Image> {/*backgroundImage: `url("${category.img_src}")` */}
								<div className="white pa2 pa3-ns" style={{ backgroundColor: `white`, backgroundSize: "cover", backgroundPosition: "center", minWidth: "500px", minHeight: "240px", maxHeight: "240px" }}>
								<p className="black-30 pt3 f5 b pl4">
									{category.desc.desc && category.desc.desc.length > 0 ? <p className="black-50 f6 pt2">
									{category.desc.desc.substring(0, 40)}
									{category.desc.desc.length > 1 ? "..." : ""}
              </p> : <p className="black-50 f6 pt2">{category.title}</p>}</p>
								<Link className={"black db pa3 pl4 pt5 mt4 f3 b hover-primary underline-hover transition LinkBackgroundStyle"} to={base}>{category.desc.short_des}</Link>
								<Link className={" $primary db pl4 pr3 pb4 f5 b hover-primary underline-hover transition LinkBackgroundStyle"} style={{color: "#a2cf66"}} to={base}>Produkte ansehen</Link>

							</div>
						</Card>
						)}
				</MediaQuery>
			)
		}
			


		if ( category.getParents && !overflow ) {
			//console.log("CategoryCard", category)
			let parents = category.getParents()
			let base = `/collection/${parents.map( id => `${id}/` ).join( "" )}${category.map_id}/`
			//console.log("categoryID PATH CAT CARD: ", base, category.map_id, parents)
			if(shop.config.plugin && shop.config.plugin.SEOCategoryLink){
				const seoCategory = categoryStore._SEOCategoryTree['/' + parents.map( id => `${id}/` ).join( "" ) + category.map_id];
				base = `/collection/${seoCategory.textpath.substring(1)}`;
				//console.log("SEO Category Tree categoryID", seoCategory,category.map_id, base)
			}
			const buttonWidth = window.innerWidth < 768
			? `calc(100vw - 20vw)` // 80% of screen width for mobile
			: "250px"; // desktop fallback
			return (
				<MediaQuery maxWidth={767}>
					{(matches) =>
					
						matches ? (<div className="pa2 flex flex-column justify-center items-center">
							<Button
								style={{
									backgroundColor: "#ffffff",
									width: buttonWidth,
									height: "50px",
									borderRadius: "35px",
									color: "black",
									border: "2px solid rgb(221, 218, 218)",
								}}
								as={Link}
								to={base}
								onMouseEnter={(e) => {
									e.target.style.backgroundColor = "#a2cf66";
									e.target.style.color = "white";
									const button = e.currentTarget;
									const svg = e.target.querySelector("svg");
									if (svg) {
										svg.querySelectorAll("path").forEach(path => path.setAttribute("fill", "white"));
									}
									const p = button.querySelector("p");
									if (p) {
										p.style.color = "white";
										p.style.backgroundColor = "transparent";
									}
									const div = button.querySelector("div");
									if (div) {
										p.style.color = "white";
										p.style.backgroundColor = "transparent";
									}
								}}
								onMouseLeave={(e) => {
									// Always reset the button background and color
									const button = e.currentTarget;
									button.style.backgroundColor = "#ffffff";
									button.style.color = "black";
									// Reset SVG path colors
									const svg = button.querySelector("svg");
									if (svg) {
										const fills = [
											"#a2cf66", "#a2cf66", "#a2cf66", "#a2cf66", "#a2cf66", "#a2cf66", "#a2cf66"
										];
										svg.querySelectorAll("path").forEach((path, i) => path.setAttribute("fill", fills[i] || "#a2cf66"));
									}
									// Reset <p> color if it was changed
									const p = button.querySelector("p");
									if (p) {
										p.style.color = "black";
										p.style.backgroundColor = "transparent";
									}
									const div = button.querySelector("div");
									if (div) {
										// Reset all <p> inside the div
										const ps = div.querySelectorAll("p");
										ps.forEach(pTag => {
											pTag.style.color = "black";
											pTag.style.backgroundColor = "transparent";
										});
										// Reset the div itself
										div.style.color = "black";
										div.style.backgroundColor = "transparent";
									}
								}}
							>
							<div className="flex flex-row f5 justify-center items-center" style={{width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
								{/*								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
									<path d="M1.82402 20.0002C1.35563 20.0002 0.88912 19.82 0.534659 19.4657C-0.123213 18.8075 -0.180948 17.7636 0.400172 17.0373L1.7106 15.3991C1.80946 15.2756 1.85828 15.1209 1.84852 14.9633L1.78222 13.9033C1.75207 13.4203 1.9311 12.9471 2.27322 12.605L9.83721 5.04061C10.0428 4.83502 10.3758 4.83502 10.5814 5.04061C10.787 5.24603 10.787 5.57942 10.5814 5.78484L3.01744 13.3492C2.88878 13.478 2.82145 13.6561 2.83275 13.8377L2.89905 14.8975C2.92527 15.3169 2.79506 15.7286 2.5326 16.0567L1.22217 17.6949C0.976492 18.0019 1.00099 18.4432 1.27905 18.7213C1.55693 18.9995 1.99808 19.0235 2.30526 18.778L3.94343 17.4675C4.27168 17.2052 4.68285 17.0766 5.10258 17.1011L6.16255 17.1674C6.34671 17.18 6.52215 17.1115 6.65081 16.9827L12.6023 11.031C12.8079 10.8254 13.141 10.8254 13.3465 11.031C13.5521 11.2364 13.5521 11.5698 13.3465 11.7752L7.39503 17.7269C7.05272 18.0691 6.57748 18.2476 6.09693 18.2179L5.0368 18.1516C4.8797 18.142 4.72448 18.1909 4.60096 18.2896L2.96278 19.6C2.62785 19.868 2.22508 20.0002 1.82402 20.0002Z" fill="#a2cf66"/>
									<path d="M9.38819 9.49652C9.25354 9.49652 9.11888 9.44513 9.01608 9.34233L7.64809 7.9743C7.4425 7.76888 7.4425 7.43548 7.64809 7.23006C7.85367 7.02447 8.18672 7.02447 8.3923 7.23006L9.7603 8.5981C9.96589 8.80352 9.96589 9.13691 9.7603 9.34233C9.65751 9.44513 9.52285 9.49652 9.38819 9.49652Z" fill="#a2cf66"/>
									<path d="M7.4734 11.4116C7.33874 11.4116 7.20408 11.3602 7.10129 11.2574L5.73329 9.88934C5.52771 9.68392 5.52771 9.35052 5.73329 9.1451C5.93888 8.93951 6.27192 8.93951 6.47751 9.1451L7.84551 10.5131C8.05109 10.7186 8.05109 11.052 7.84551 11.2574C7.74271 11.3602 7.60806 11.4116 7.4734 11.4116Z" fill="#a2cf66"/>
									<path d="M5.55787 13.3268C5.42321 13.3268 5.28855 13.2754 5.18576 13.1726L3.81776 11.8046C3.61218 11.5991 3.61218 11.2657 3.81776 11.0603C4.02335 10.8547 4.3564 10.8547 4.56198 11.0603L5.92998 12.4284C6.13556 12.6338 6.13556 12.9672 5.92998 13.1726C5.82718 13.2754 5.69253 13.3268 5.55787 13.3268Z" fill="#a2cf66"/>
									<path d="M14.4048 10.1343C14.2691 10.1343 14.1343 10.082 14.0325 9.98011L10.0197 5.96716C9.83776 5.78521 9.81394 5.49841 9.9635 5.28905L12.5057 1.72993C13.2131 0.73967 14.3144 0.114161 15.5271 0.0137656C16.7396 -0.0861179 17.9291 0.349219 18.7896 1.20996C19.6502 2.07053 20.0862 3.2597 19.9858 4.47251C19.8854 5.68533 19.2599 6.78661 18.2696 7.49401L14.7106 10.0363C14.6185 10.1021 14.5114 10.1343 14.4048 10.1343ZM11.0791 5.53816L14.4615 8.92064L17.6577 6.63738C18.3957 6.11021 18.8619 5.28956 18.9368 4.38565C19.0116 3.48174 18.6866 2.59564 18.0454 1.9542C17.404 1.31293 16.5176 0.987752 15.614 1.06279C14.7101 1.13766 13.8895 1.60384 13.3623 2.34191L11.0791 5.53816Z" fill="#a2cf66"/>
									<path d="M14.6462 3.78524C14.5403 3.78524 14.4336 3.75337 14.3407 3.68724C14.1043 3.51831 14.0495 3.18953 14.2184 2.95294C14.6037 2.4136 15.2059 2.10419 15.8703 2.10419C16.4098 2.10419 16.9177 2.31509 17.3006 2.698C17.5062 2.90342 17.5062 3.23682 17.3006 3.44224C17.0951 3.64783 16.762 3.64783 16.5564 3.44224C16.3723 3.25824 16.1286 3.15681 15.8703 3.15681C15.5501 3.15681 15.2602 3.30552 15.075 3.56491C14.9722 3.70865 14.8105 3.78524 14.6462 3.78524Z" fill="#a2cf66"/>
									<path d="M15.408 11.1392C15.2733 11.1392 15.1386 11.0878 15.0358 10.985L9.01649 4.96551C8.81091 4.76009 8.81091 4.42669 9.01649 4.22127C9.22208 4.01568 9.55513 4.01568 9.76071 4.22127L15.7801 10.2408C15.9856 10.4462 15.9856 10.7796 15.7801 10.985C15.6773 11.0878 15.5426 11.1392 15.408 11.1392Z" fill="#a2cf66"/>
								</svg> */}
								<p className="">{category.desc.short_des}</p></div></Button>
							</div>
						)
						: (<div className="pa2">
							<Button
								style={{
									backgroundColor: "#ffffff",
									width: "250px",
									height: "50px",
									borderRadius: "35px",
									color: "black",
									border: "2px solid rgb(221, 218, 218)",
								}}
								as={Link}
								to={base}
								onMouseEnter={(e) => {
									e.target.style.backgroundColor = "#a2cf66";
									e.target.style.color = "white";
									const button = e.currentTarget;
									const svg = e.target.querySelector("svg");
									if (svg) {
										svg.querySelectorAll("path").forEach(path => path.setAttribute("fill", "white"));
									}
									const p = button.querySelector("p");
									if (p) {
										p.style.color = "white";
										p.style.backgroundColor = "transparent";
									}
									const div = button.querySelector("div");
									if (div) {
										p.style.color = "white";
										p.style.backgroundColor = "transparent";
									}
								}}
								onMouseLeave={(e) => {
									// Always reset the button background and color
									const button = e.currentTarget;
									button.style.backgroundColor = "#ffffff";
									button.style.color = "black";
									// Reset SVG path colors
									const svg = button.querySelector("svg");
									if (svg) {
										const fills = [
											"#a2cf66", "#a2cf66", "#a2cf66", "#a2cf66", "#a2cf66", "#a2cf66", "#a2cf66"
										];
										svg.querySelectorAll("path").forEach((path, i) => path.setAttribute("fill", fills[i] || "#a2cf66"));
									}
									// Reset <p> color if it was changed
									const p = button.querySelector("p");
									if (p) {
										p.style.color = "black";
										p.style.backgroundColor = "transparent";
									}
									const div = button.querySelector("div");
									if (div) {
										// Reset all <p> inside the div
										const ps = div.querySelectorAll("p");
										ps.forEach(pTag => {
											pTag.style.color = "black";
											pTag.style.backgroundColor = "transparent";
										});
										// Reset the div itself
										div.style.color = "black";
										div.style.backgroundColor = "transparent";
									}
								}}
							>
							<div className="flex flex-row f5 justify-center items-center" style={{width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
								{/*								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
									<path d="M1.82402 20.0002C1.35563 20.0002 0.88912 19.82 0.534659 19.4657C-0.123213 18.8075 -0.180948 17.7636 0.400172 17.0373L1.7106 15.3991C1.80946 15.2756 1.85828 15.1209 1.84852 14.9633L1.78222 13.9033C1.75207 13.4203 1.9311 12.9471 2.27322 12.605L9.83721 5.04061C10.0428 4.83502 10.3758 4.83502 10.5814 5.04061C10.787 5.24603 10.787 5.57942 10.5814 5.78484L3.01744 13.3492C2.88878 13.478 2.82145 13.6561 2.83275 13.8377L2.89905 14.8975C2.92527 15.3169 2.79506 15.7286 2.5326 16.0567L1.22217 17.6949C0.976492 18.0019 1.00099 18.4432 1.27905 18.7213C1.55693 18.9995 1.99808 19.0235 2.30526 18.778L3.94343 17.4675C4.27168 17.2052 4.68285 17.0766 5.10258 17.1011L6.16255 17.1674C6.34671 17.18 6.52215 17.1115 6.65081 16.9827L12.6023 11.031C12.8079 10.8254 13.141 10.8254 13.3465 11.031C13.5521 11.2364 13.5521 11.5698 13.3465 11.7752L7.39503 17.7269C7.05272 18.0691 6.57748 18.2476 6.09693 18.2179L5.0368 18.1516C4.8797 18.142 4.72448 18.1909 4.60096 18.2896L2.96278 19.6C2.62785 19.868 2.22508 20.0002 1.82402 20.0002Z" fill="#a2cf66"/>
									<path d="M9.38819 9.49652C9.25354 9.49652 9.11888 9.44513 9.01608 9.34233L7.64809 7.9743C7.4425 7.76888 7.4425 7.43548 7.64809 7.23006C7.85367 7.02447 8.18672 7.02447 8.3923 7.23006L9.7603 8.5981C9.96589 8.80352 9.96589 9.13691 9.7603 9.34233C9.65751 9.44513 9.52285 9.49652 9.38819 9.49652Z" fill="#a2cf66"/>
									<path d="M7.4734 11.4116C7.33874 11.4116 7.20408 11.3602 7.10129 11.2574L5.73329 9.88934C5.52771 9.68392 5.52771 9.35052 5.73329 9.1451C5.93888 8.93951 6.27192 8.93951 6.47751 9.1451L7.84551 10.5131C8.05109 10.7186 8.05109 11.052 7.84551 11.2574C7.74271 11.3602 7.60806 11.4116 7.4734 11.4116Z" fill="#a2cf66"/>
									<path d="M5.55787 13.3268C5.42321 13.3268 5.28855 13.2754 5.18576 13.1726L3.81776 11.8046C3.61218 11.5991 3.61218 11.2657 3.81776 11.0603C4.02335 10.8547 4.3564 10.8547 4.56198 11.0603L5.92998 12.4284C6.13556 12.6338 6.13556 12.9672 5.92998 13.1726C5.82718 13.2754 5.69253 13.3268 5.55787 13.3268Z" fill="#a2cf66"/>
									<path d="M14.4048 10.1343C14.2691 10.1343 14.1343 10.082 14.0325 9.98011L10.0197 5.96716C9.83776 5.78521 9.81394 5.49841 9.9635 5.28905L12.5057 1.72993C13.2131 0.73967 14.3144 0.114161 15.5271 0.0137656C16.7396 -0.0861179 17.9291 0.349219 18.7896 1.20996C19.6502 2.07053 20.0862 3.2597 19.9858 4.47251C19.8854 5.68533 19.2599 6.78661 18.2696 7.49401L14.7106 10.0363C14.6185 10.1021 14.5114 10.1343 14.4048 10.1343ZM11.0791 5.53816L14.4615 8.92064L17.6577 6.63738C18.3957 6.11021 18.8619 5.28956 18.9368 4.38565C19.0116 3.48174 18.6866 2.59564 18.0454 1.9542C17.404 1.31293 16.5176 0.987752 15.614 1.06279C14.7101 1.13766 13.8895 1.60384 13.3623 2.34191L11.0791 5.53816Z" fill="#a2cf66"/>
									<path d="M14.6462 3.78524C14.5403 3.78524 14.4336 3.75337 14.3407 3.68724C14.1043 3.51831 14.0495 3.18953 14.2184 2.95294C14.6037 2.4136 15.2059 2.10419 15.8703 2.10419C16.4098 2.10419 16.9177 2.31509 17.3006 2.698C17.5062 2.90342 17.5062 3.23682 17.3006 3.44224C17.0951 3.64783 16.762 3.64783 16.5564 3.44224C16.3723 3.25824 16.1286 3.15681 15.8703 3.15681C15.5501 3.15681 15.2602 3.30552 15.075 3.56491C14.9722 3.70865 14.8105 3.78524 14.6462 3.78524Z" fill="#a2cf66"/>
									<path d="M15.408 11.1392C15.2733 11.1392 15.1386 11.0878 15.0358 10.985L9.01649 4.96551C8.81091 4.76009 8.81091 4.42669 9.01649 4.22127C9.22208 4.01568 9.55513 4.01568 9.76071 4.22127L15.7801 10.2408C15.9856 10.4462 15.9856 10.7796 15.7801 10.985C15.6773 11.0878 15.5426 11.1392 15.408 11.1392Z" fill="#a2cf66"/>
								</svg> */}
								<p className="">{category.desc.short_des}</p></div></Button>
							</div>
						)}
				</MediaQuery>
			)
			

		}


		return null
	}
}


// WEBPACK FOOTER //
// ./src/theme/trendimport.test/plugin/CategoryShortcuts/CategoryCard.js